<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{$t('Turnover-Profit-Analysis-Report')}} </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <!-- <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile> -->

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                      </v-flex>
                      <v-flex xs12 pt-2 sm6 md3>
                        <v-autocomplete v-model="Rapor.DovizTipi" :items="doviztipi" item-text="Title"
                          :rules="[v => !!v || $t('Choose-Currency-Exchange-Rate')]" item-value="DovizKod" :label="$t('Currency-Type')"
                          clearable></v-autocomplete>
                      </v-flex>


                      <v-flex pt-2>
                        <v-layout align-center="" fill-height="">
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{ $t('Add-Search-Filter') }}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>


                <v-flex xs12 v-for="item in itemssatis" v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
                  v-bind:key="item.id" sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="subheading red--text font-weight-"> {{item.Tarih | dateformat}} </span>
                              &nbsp;
                              <v-divider vertical></v-divider> &nbsp; <span class="subheading grey--text font-weight-">
                                {{ $t('Revenue-Profit-History-Analysis') }}
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{ $t('Domestic-Line') }} (TL)
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{Sales}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                        {{ $t('Sales-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{  $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{ $t('Domestic-Line') }} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.Satis | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                        {{ $t('Sales-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.SatisKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.SatisIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.Iade | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.IadeKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.IadeIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.ToplamServis | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.Net | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.IcHatTutarlarDvz.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{ $t('International-Line') }} (TL)
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>

                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.Satis | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                        {{ $t('Sales-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{ $t('International-Line') }} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.Satis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                        {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.Iade | moneyformat}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{  $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.Net | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.DisHatTutarlarDvz.NetKar | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{$t('Total')}} (TL)
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>

                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.Satis | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                          </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{$t('Total')}} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.Satis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                          </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                        {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.Iade | moneyformat}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.Net | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.ToplamHatTutarlarDvz.NetKar | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{ $t('Domestic-Line') }} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{ $t('International-Line') }} (TL)
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}}</span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('International-Line')}} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('Total')}} (TL)
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{ $t('Total') }} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex xs12 v-for="item in itemssatis"
                  v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                  v-bind:key="item.Tarih" sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">

                              <span class="subheading red--text font-weight-"> {{item.Tarih | dateformat}} </span>
                              &nbsp;
                              <v-divider vertical></v-divider> &nbsp;
                               <span class="subheading grey--text font-weight-">
                                  {{ $t('Revenue-Profit-History-Analysis') }}
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Sales-Commission') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Sales-Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Refund')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Returns-Commission') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Returns-Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Total-Services') }} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                    {{ $t('Net') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Net-Profit')}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{ $t('Domestic-Line') }} (TL)
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{ $t('Domestic-Line') }} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.IcHatTutarlarDvz.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('International-Line')}} (TL)
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.ToplamServis| moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('International-Line')}} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.DisHatTutarlarDvz.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('Total')}} (TL)
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.Net | moneyformat }}{{getparabirimi()}}</span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('Total')}} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.ToplamHatTutarlarDvz.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>


                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                
                <v-flex xs12 v-if="itemssatis && itemssatis.length > 0" sm12 md12 pb-3>
                  <div class="ciro-kar-report-table">
                    <ReportTable
                      :headers="ciroKarHeaders"
                      :items="ciroKarReportItems"
                      storage-key="cirokaranalizi_columns"
                      :loading="progress"
                      :has-searched="itemssatis && itemssatis.length > 0"
                      :show-search="true"
                      :search-label="$t('Search')"
                      :show-frontend-export="true"
                      :export-title="$t('Turnover-Profit-Analysis-Report')"
                      :export-meta-items="ciroKarExportMetaItems"
                      :export-summary-cards="ciroKarSummaryCards"
                      :rows-per-page-items="[20, 50, 100, 250, 500, 1000]"
                    ></ReportTable>
                  </div>
                </v-flex>

<v-flex xs12 v-for="item in itemssatisgeneltoplam"
                  v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                  v-bind:key="item.id" sm12 md12 pb-3>
                  <v-card flat class="black--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">

                              <span class="subheading red--text font-weight-bold"> {{ $t('General-Totals') }}
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-1 font-weight-">
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                     {{ $t('Sales-Commission') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Sales-Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Refund')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                       {{ $t('Returns-Commission') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                       {{ $t('Returns-Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Total-Services') }} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{ $t('Net') }} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-1 font-weight-">
                                      {{$t('Net-Profit')}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{ $t('Domestic-Line') }} (TL)
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}}</span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}}</span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}}</span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{ $t('Domestic-Line') }} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelIcHatTutarlarDvz.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('International-Line')}} (TL)
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.Net | moneyformat }}{{getparabirimi()}}</span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('International-Line')}} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelDisHatTutarlar.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('Total')}} (TL)
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}}</span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>

                          <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
                            xs12 sm12 md12>
                            <v-card flat class="black--text">

                              <v-divider light></v-divider>
                              <v-layout>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{$t('Total')}} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.Satis | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.Iade | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.Net | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs2 sm2 md1>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="caption font-weight-thin">
                                      {{item.GenelToplamHatTutarlarDvz.NetKar | moneyformat}} </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                            </v-card>
                          </v-flex>


                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex xs12 v-for="item in itemssatisgeneltoplam"
                  v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" v-bind:key="item.id" sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="subheading red--text font-weight-"> {{ $t('General-Totals') }} </span>
                              &nbsp;
                              <v-divider vertical></v-divider> &nbsp;

                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{$t('Domestic-Line')}} (TL)
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.Satis | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                          </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                         {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{ $t('Domestic-Line') }} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.Satis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                          </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                        {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.Iade | moneyformat}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.Net | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelIcHatTutarlarDvz.NetKar | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>

                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{$t('International-Line')}} (TL)
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>

                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.Satis | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                          </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                         {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{$t('International-Line')}} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.Satis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                          </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                         {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.Iade | moneyformat}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.Net | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelDisHatTutarlarDvz.NetKar | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>

                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{$t('Total')}} (TL)
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>

                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.Satis | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                          </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.SatisKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                        {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.SatisIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.Iade | moneyformat }}{{getparabirimi()}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.IadeKomisyon | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.IadeIskonto | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.ToplamServis | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.Net | moneyformat }}{{getparabirimi()}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlar.NetKar | moneyformat }}{{getparabirimi()}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="">
                                    <span style=" vertical-align='middle' align-items='center'">
                                      {{$t('Total')}} ({{$t('Currency')}})
                                    </span>
                                  </v-layout>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-divider></v-divider>

                                <v-flex xs12 sm12 md12>
                                  <v-layout row wrap>

                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Sales')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.Satis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-start="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{ $t('Sales-Commission') }}
                                          </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.SatisKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                         {{ $t('Sales-Discount') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.SatisIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Refund')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.Iade | moneyformat}}</span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Returns-Commission') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.IadeKomisyon | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Returns-Discount')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.IadeIskonto | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                           {{ $t('Total-Services') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.ToplamServis | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{ $t('Net') }}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.Net | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-star="">
                                        <span style=" vertical-align='middle' align-items='center'">
                                          {{$t('Net-Profit')}}
                                        </span>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex xs6 sm6 md6>
                                      <v-layout align-center="" justify-end="" fill-height="">
                                        <span class="body-1 font-weight-">
                                          {{item.GenelToplamHatTutarlarDvz.NetKar | moneyformat}} </span>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>



                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title> {{ $t('Filter-selection') }} </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                              <v-radio-group v-model="Rapor.KurTipi" hide-details>
                                <v-radio :value="0" :label="$t('Real-Daily-Exchange-Rate')"></v-radio>
                                <v-radio :value="1" :label="$t('Average-Exchange-Rate')"></v-radio>
                                <v-radio :value="2" :label="$t('User-Exchange-Entry')"></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex v-if="kullanicigirisi" xs12 sm12 md12>
                              <dovizinput :isPositive="true" v-model="Rapor.KurTutar" :etiket="$t('Foreign-Currency-Exchange-Rate-Amount')"
                                :autocomplete="'autocomplete'"></dovizinput>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-radio-group v-model="Rapor.DetayOzet" hide-details>
                                <v-radio :value="0" :label="$t('Details')"></v-radio>
                                <v-radio :value="1" :label="$t('Summary')"></v-radio>
                              </v-radio-group>
                            </v-flex>



                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.IcHatKdvDus" :label="$t('Deduct-VAT')" hide-details="">
                              </v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.TaxDahil" :label="$t('VAT-Included')" hide-details="">
                              </v-checkbox>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog v-model="tarihdialog" scrollable="" max-width="300px">
            <v-card flat color="grey lighten-5">
              <v-card-title>{{ $t('Dates-without-Exchange-Data') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-layout row="" wrap="">
                      <v-flex xs12 sm12 md12>
                        <v-card>
                          <v-data-table :headers="headerstarih" :rows-per-page-items=[50,100] :items="itemstarih">
                            <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                              <td class="text-xs-left">{{ props.item | dateformat }}</td>
                              <td class="justify-center layout px-0">
                                <v-btn icon @click="kurekleDialogac(props.item)" class="mx-0">
                                  <v-icon color="teal">edit</v-icon>
                                </v-btn>

                              </td>
                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                               {{ $t('No-records-searched-for', { value: search3}) }}
                            </v-alert>
                          </v-data-table>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="tarihdialog=false">{{$t("cancel_button")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog scrollable="" max-width="300px">
            <v-card flat color="grey lighten-5">
              <v-card-title>{{$t('Exchange-Entry')}}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-layout row="" wrap="">
                      <v-flex xs12 sm12 md12>
                        <dovizinput :isPositive="true" v-model="kurTutar" :etiket="$t('Exchange-Amount')" :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="kurekledialog=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click="kurekle()"> {{ $t('Save-Currency') }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>



          <v-dialog v-model="kurekledialog" persistent="" max-width="300px">
            <v-card flat color="grey lighten-5">
              <v-card-title>{{$t('Exchange-Entry')}}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-layout row="" wrap="">
                      <v-flex xs12 sm12 md12>
                        <dovizinput :isPositive="true"  v-model="kur.EfektifAlis" :etiket="$t('Effective-Purchase-Price')"
                          :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <dovizinput :isPositive="true" v-model="kur.EfektifSatis" :etiket="$t('Effective-Sales-Price')"
                          :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <dovizinput :isPositive="true" v-model="kur.Alis" :etiket="$t('Purchase-Price')" :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <dovizinput :isPositive="true" v-model="kur.Satis" :etiket="$t('Sales-Amount-v2')" :autocomplete="'autocomplete'">
                        </dovizinput>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="kurekledialog=false">{{$t("cancel_button")}}</v-btn>
                <v-tooltip bottom>
                  <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="kurKaydet()" flat>
                    {{ $t('Update') }}
                  </v-btn>
                  <span v-if="!sayfayetki.Update"> {{ $t('Limited-Authorization') }} </span>
                  <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-dialog>


        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import ReportTable from "@/components/app/customcomp/ReportTable.vue"


  export default {
    data() {
      return {
        itemskur:[],
        kur: {
          Ref: null,
          Tarih: null,
          Para: null,
          Kur: 0,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          SirketNo: null,
          Alis: 0,
          Satis: 0,
          EfektifAlis: 0,
          EfektifSatis: 0,
        },
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        kurTarih: null,
        kurTutar: 0,
        kurekledialog: false,
        doviztipi: [],
        kullanicigirisi: false,
        itemssatisgeneltoplam: [],
        tarihdialog: false,
        itemstarih: [],
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        referansitems: [],
        evraktipi: [],
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        genTop: {
          Bilet: 0,
          EkIndirim: 0,
          Iskonto: 0,
          Komisyon: 0,
          NetKar: 0,
          Servis: 0,
          Toplam: 0,
          Vergi: 0,
        },
        Rapor: {
          DovizTipi: null,
          KurTipi: 0, // 0 : Reel Günlük Kur, 1 : Ortalama Kur, 2 : Kullanıcı Girişi
          DetayOzet: 0, // 0 : Detay, 1 : Ozet
          KurTutar: 0,
          IcHatKdvDus: false,
          TaxDahil: false,
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
        },
        valid: true,
        tumsirketler: '',
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemsiade: [],
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          CompanyCode: credentials.SirketKodu
        }


        this.$http.post(auth.API_URL + 'api/currency/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz Tipi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Döviz Tipi'
            this.snackbar = true
          }
        })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      analizcomp,
      havayollaricomp,
      dovizinput,
      yetkidialog,
      ReportTable
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      },
      'Rapor.KurTipi': function (vall) {
        if (vall == 2) {
          this.kullanicigirisi = true
          this.Rapor.KurTutar = 0

        } else {
          this.kullanicigirisi = false
        }
      },
    },
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
      kurekleDialogac(valtarih) {
        this.kur.Tarih = valtarih


        // this.kurTarih = valtarih
        this.kurekledialog = true
      },
      kurekle() {



        if (this.kurTutar > 0) {

          var list = []

          var params = {
            Tarih: this.kurTarih,
            DovizKod: this.Rapor.DovizTipi,
            KurTutar: this.kurTutar
          }

          list.push(params)

          this.$http.post(auth.API_URL + 'api/Definitions/CurrencyRateSave', list, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

             this.text1 = this.$t(response.body.ResponseMessage);
            this.snackbar = true
            if (response.body.Status === true) {
              this.kurekledialog = false
              var index = this.itemstarih.indexOf(this.kurTarih)

              this.itemstarih.splice(index, 1)

              if (this.itemstarih.length == 0) {
                this.tarihdialog = false
                this.getList();
              }
            }


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.progress = false

              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.progress = false

              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Kur değerini 0 üzeri giriniz'
          this.snackbar = true

        }




      },

      kurKaydet() {
        this.itemskur=[]

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.kur.Para = this.Rapor.DovizTipi
        this.kur.SirketNo = credentials.SirketKodu
        this.kur.Kur = this.kur.Satis
        this.itemskur.push(this.kur)

        var params = this.itemskur

        this.$http.post(auth.API_URL + 'api/Definitions/WebRateSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true
          if (response.body.Status === true) {
            this.kurekledialog = false
            this.tarihdialog = false
          }


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
          }
        })

      },

      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      carigetir: carigetir
    },
    computed:{
       ciroKarHeaders(){
         return [
          { text: this.$t('Date'), value: 'Tarih', visible: true, sortable: true, type: 'date', align: 'left', width: '140px' },
          { text: this.$t('Line-Type'), value: 'HatTipi', visible: true, sortable: true, type: 'text', align: 'left', width: '180px' },
          { text: this.$t('Currency-Type'), value: 'ParaTipi', visible: true, sortable: true, type: 'text', align: 'left', width: '140px' },
          { text: this.$t('Sales'), value: 'Satis', visible: true, sortable: true, type: 'money', align: 'right', width: '150px' },
          { text: this.$t('Sales-Commission'), value: 'SatisKomisyon', visible: true, sortable: true, type: 'money', align: 'right', width: '170px' },
          { text: this.$t('Sales-Discount'), value: 'SatisIskonto', visible: true, sortable: true, type: 'money', align: 'right', width: '170px' },
          { text: this.$t('Refund'), value: 'Iade', visible: true, sortable: true, type: 'money', align: 'right', width: '150px' },
          { text: this.$t('Returns-Commission'), value: 'IadeKomisyon', visible: true, sortable: true, type: 'money', align: 'right', width: '180px' },
          { text: this.$t('Returns-Discount'), value: 'IadeIskonto', visible: true, sortable: true, type: 'money', align: 'right', width: '180px' },
          { text: this.$t('Total-Services'), value: 'ToplamServis', visible: true, sortable: true, type: 'money', align: 'right', width: '170px' },
          { text: this.$t('Net'), value: 'Net', visible: true, sortable: true, type: 'money', align: 'right', width: '150px' },
          { text: this.$t('Net-Profit'), value: 'NetKar', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' }
         ]
       },

       ciroKarReportItems(){
         var result = []
         var list = Array.isArray(this.itemssatis) ? this.itemssatis : []

         function addRow(source, tarih, hatTipi, paraTipi) {
           if (!source) return

           result.push({
             Tarih: tarih,
             HatTipi: hatTipi,
             ParaTipi: paraTipi,
             Satis: source.Satis,
             SatisKomisyon: source.SatisKomisyon,
             SatisIskonto: source.SatisIskonto,
             Iade: source.Iade,
             IadeKomisyon: source.IadeKomisyon,
             IadeIskonto: source.IadeIskonto,
             ToplamServis: source.ToplamServis,
             Net: source.Net,
             NetKar: source.NetKar
           })
         }

         list.forEach((item) => {
           addRow(item.IcHatTutarlar, item.Tarih, this.$t('Domestic-Line'), 'TL')
           addRow(item.IcHatTutarlarDvz, item.Tarih, this.$t('Domestic-Line'), this.$t('Currency'))
           addRow(item.DisHatTutarlar, item.Tarih, this.$t('International-Line'), 'TL')
           addRow(item.DisHatTutarlarDvz, item.Tarih, this.$t('International-Line'), this.$t('Currency'))
           addRow(item.ToplamHatTutarlar, item.Tarih, this.$t('Total'), 'TL')
           addRow(item.ToplamHatTutarlarDvz, item.Tarih, this.$t('Total'), this.$t('Currency'))
         })

         return result
       },

       ciroKarExportMetaItems(){
         return [
           { label: this.$t('Starting-Date'), value: this.Rapor ? this.Rapor.BaslangicTarih : '', type: 'date' },
           { label: this.$t('Finishing-Date'), value: this.Rapor ? this.Rapor.BitisTarih : '', type: 'date' },
           { label: this.$t('Currency-Type'), value: this.Rapor ? this.Rapor.DovizTipi : '' },
           { label: this.$t('All-Companies'), value: this.tumsirketler === true ? 'Evet' : 'Hayır' }
         ]
       },

       ciroKarSummaryCards(){
         var list = Array.isArray(this.itemssatisgeneltoplam) ? this.itemssatisgeneltoplam : []
         if (!list.length) return []

         var item = list[0]
         var cards = []

         var addCard = (title, source) => {
           if (!source) return
           cards.push({
             title: title,
             items: [
               { label: this.$t('Sales'), value: source.Satis, type: 'money' },
               { label: this.$t('Sales-Commission'), value: source.SatisKomisyon, type: 'money' },
               { label: this.$t('Sales-Discount'), value: source.SatisIskonto, type: 'money' },
               { label: this.$t('Refund'), value: source.Iade, type: 'money' },
               { label: this.$t('Returns-Commission'), value: source.IadeKomisyon, type: 'money' },
               { label: this.$t('Returns-Discount'), value: source.IadeIskonto, type: 'money' },
               { label: this.$t('Total-Services'), value: source.ToplamServis, type: 'money' },
               { label: this.$t('Net'), value: source.Net, type: 'money' },
               { label: this.$t('Net-Profit'), value: source.NetKar, type: 'money' }
             ]
           })
         }

         addCard(this.$t('Domestic-Line') + ' (TL)', item.GenelIcHatTutarlar)
         addCard(this.$t('Domestic-Line') + ' (' + this.$t('Currency') + ')', item.GenelIcHatTutarlarDvz)
         addCard(this.$t('International-Line') + ' (TL)', item.GenelDisHatTutarlar)
         addCard(this.$t('International-Line') + ' (' + this.$t('Currency') + ')', item.GenelDisHatTutarlarDvz)
         addCard(this.$t('Total') + ' (TL)', item.GenelToplamHatTutarlar)
         addCard(this.$t('Total') + ' (' + this.$t('Currency') + ')', item.GenelToplamHatTutarlarDvz)

         return cards
       },


       headerstarih(){
         return [{
          text: this.$t('Date'),
          value: 'Tarih',
          sortable: false
        }, {
          text: this.$t('Currency-Exchange-Rate'),
          value: 'Kur',
          sortable: false
        }]
        },
        headerssatis(){
          return [{
            text: this.$t('Ticket-No'),
            value: 'BiletNo'
          },
          {
            text: this.$t('Customer-Code'),
            value: 'CariKod',
          },
          {
            text: this.$t('Date'),
            value: 'Tarih'
          },
          {
            text: this.$t('Ticket'),
            value: 'Bilet'
          },
          {
            text: this.$t('Tax-v2'),
            value: 'Vergi'
          },
          {
            text: this.$t('Service'),
            value: 'Servis'
          },
          {
            text: this.$t('Commission'),
            value: 'Komisyon'
          },
          {
            text: this.$t('Discount'),
            value: 'Iskonto'
          },
          {
            text: this.$t('Total'),
            value: 'Toplam'
          },
          {
            text: this.$t('Additional-Discount'),
            value: 'EkIndirim'
          },
          {
            text: this.$t('Net-Profit'),
            value: 'NetKar'
          }
        ]
        },
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
        if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz-ExpenseCenter'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz-ExpenseCenter'
        this.snackbar = true
      }
    })


  }




  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {

    this.filtrevarmi = false
    this.dialogfiltre = false

    this.Rapor.DovizTipi = null
    this.Rapor.KurTipi = 0 // 0 : Reel Günlük Kur, 1 : Ortalama Kur, 2 : Kullanıcı Girişi
    this.Rapor.DetayOzet = 0 // 0 : Detay, 1 : Ozet
    this.Rapor.KurTutar = 0
    this.Rapor.IcHatKdvDus = false
    this.Rapor.TaxDahil = false
    this.tumsirketler = ''


  }


  function carigetir(v) {
    if (v.length >= 2) {
      this.loading = true

      var params = {
        q: v,
        //c: credentials.SirketKodu,
        Coper:false,
      }


      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch',
          params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 750)
    }
  }


  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {
        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Report/EndorsementProfitAnalyseReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.ResponseReport == true) {

            if (response.body.GunDetayList != null) {

              this.itemssatisgeneltoplam = []

              var toplamlar = {
                GenelDisHatTutarlar: response.body.GenelDisHatTutarlar,
                GenelDisHatTutarlarDvz: response.body.GenelDisHatTutarlarDvz,
                GenelIcHatTutarlar: response.body.GenelIcHatTutarlar,
                GenelIcHatTutarlarDvz: response.body.GenelIcHatTutarlarDvz,
                GenelToplamHatTutarlar: response.body.GenelToplamHatTutarlar,
                GenelToplamHatTutarlarDvz: response.body.GenelToplamHatTutarlarDvz
              }


              this.itemssatisgeneltoplam.push(toplamlar)

              this.itemssatis = response.body.GunDetayList
            }

          } else {
            this.tarihdialog = true
            this.itemstarih = response.body.ResponseRateList
            this.text1 = this.$t('Dates-without-exchange-rate-information-have-been-identified.-Please-add-the-exchange-rate-for-the-relevant-dates.')
            this.snackbar = true
          }

          //    this.genTop = response.body.GenelToplamlar

          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {
        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http
          .post(auth.API_URL + "api/Report/EndorsementProfitAnalyseReportHtml", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }).then((response) => {

            if (lang=='en')
          {
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> CİRO KÂR ANALİZ RAPORU </title>','<title> TURNOVER PROFIT ANALYSIS REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>CİRO KÂR ANALİZ RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>TURNOVER PROFIT ANALYSIS REPORT</font>")
             bodyhtml=bodyhtml.toString().replaceAll("Satış","Sale")
             bodyhtml=bodyhtml.toString().replaceAll("Satış Komisyon","Sales Commission")
             bodyhtml=bodyhtml.toString().replaceAll("Satış İskonto","Sales Discount")
             bodyhtml=bodyhtml.toString().replaceAll("İade","Return")
             bodyhtml=bodyhtml.toString().replaceAll("iade Komisyon","Return Commission")
             bodyhtml=bodyhtml.toString().replaceAll("İade İskonto","Return Discount")
             bodyhtml=bodyhtml.toString().replaceAll("Net Kar","Net Profit")
             bodyhtml=bodyhtml.toString().replaceAll("tarihi ciro kar analizi","Turnover profit analysis dated")
             bodyhtml=bodyhtml.toString().replaceAll("Kur Amount","Exchange Rate Amount")
             bodyhtml=bodyhtml.toString().replaceAll("Kur Typei","Currency Type")
             bodyhtml=bodyhtml.toString().replaceAll("Ortalama Kur","Average Exchange Rate")
             bodyhtml=bodyhtml.toString().replaceAll("Detay","Detail")
             bodyhtml=bodyhtml.toString().replaceAll("General toplam ciro kar analizi","General total turnover profit analysis")
             bodyhtml=bodyhtml.toString().replaceAll("İç Hat (TL)","Domestic Line")
             bodyhtml=bodyhtml.toString().replaceAll("İç Hat (Dvz)","Domestic Line (Exc.)")
             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat (TL)","Int. Line")
             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat (Dvz)","Int. Line (Exc)")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam (TL)","Total")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam (Dvz)","Total (Exc)")

             bodyhtml=bodyhtml.toString().replaceAll("Return İskonto","Return Commision")
             bodyhtml=bodyhtml.toString().replaceAll("Total Servis","Total Service")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam Servis","Total Service")
             bodyhtml=bodyhtml.toString().replaceAll("Sale İskonto","Sale Discount")
             bodyhtml=bodyhtml.toString().replaceAll("Sale Komisyon","Sale Commision")





             response.bodyText=bodyhtml;
          }
            this.progress = false
            this.load1 = true
            var blob = new Blob([response.bodyText], {
              type: 'application/html'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('CiroKarAnalizi') + ".html";
            link.click();

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {
        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http
          .post(auth.API_URL + "api/Report/EndorsementProfitAnalyseReportExcel", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }).then((response) => {


            this.progress = false
            this.load1 = true
            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('CiroKarAnalizi') + ".xlsx";
            link.click();

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function beforeMount() {



  }
</script>
<style scoped>

/* Bu stiller yalnızca cirokaranalizi.vue sayfasına özeldir. */
.ciro-kar-report-table {
  width: 100%;
  margin-top: 8px;
}

.ciro-kar-report-table > * {
  width: 100%;
}

</style>
